import dayjs, { Dayjs } from "dayjs";
import isToday from "dayjs/plugin/isToday";
import isTomorrow from "dayjs/plugin/isTomorrow";

dayjs.extend(isToday);
dayjs.extend(isTomorrow);
class DateHelper {
    static toDisplayDate(isoDate: string | null): string {
        if (!isoDate) {
            return "";
        }

        return dayjs(isoDate).format("MM/DD/YYYY");
    }

    static isWeekend(date: Dayjs) {
        const day = date.day();
        return day === 0 || day === 6;
    }

    static isToday(date: Dayjs) {
        return date.isToday();
    }

    static isTomorrow(date: Dayjs) {
        return date.isTomorrow();
    }

    static toFullMonthYear(monthYear: string | null): string {
        if (!monthYear) {
            return "";
        }
        
        return dayjs(monthYear, ["MM-YYYY", "MM/YYYY"]).format("MMMM YYYY");
    }
}

export default DateHelper;
